package com.example.mystybag.database.communication.db

import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.driver.worker.WebWorkerDriver

/**
 * Реален SQL driver за Web: SQL.js в Web Worker.
 * Worker се подава като dynamic, защото типът Worker не е публично експортиран от SQLDelight.
 */
actual class DatabaseDriverFactory {

    actual fun createDriver(): SqlDriver {
        // URL и Worker трябва да са в един js() блок, за да резолвне webpack worker скрипта при bundle (SQLDelight docs).
        // type: 'module' е задължителен – worker скриптът използва import.
        val worker: dynamic = js("new Worker(new URL('@cashapp/sqldelight-sqljs-worker/sqljs.worker.js', import.meta.url), { type: 'module' })")
        return WebWorkerDriver(worker)
    }
}
